import { IDoctor } from "./doctor"
import { IRoom } from "./room";

export type IRegisterState = {
  type: RegisterType,
  employee?: IDoctor,
  room?: IRoom
};

export enum RegisterType {
  EmergencyRoom = 'ER',
  Doctor = 'doctor',
  Prescription = 'prescription',
  Lab = 'lab',
  Reception = 'reception',
  Help = 'help',
  Partners = 'partners',
  Vaccine = 'vaccine',
};
